module.exports = __webpack_public_path__ + "static/section1-709b6ed762aef92e322ece061769822b.svg";